"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var Supplier = /** @class */ (function () {
    function Supplier() {
    }
    Object.defineProperty(Supplier.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (value) {
            this.setValue(value);
        },
        enumerable: true,
        configurable: true
    });
    Supplier.prototype.setValue = function (value) {
        this._value = value;
    };
    Supplier.prototype.clearValue = function () {
        this._value = undefined;
    };
    __decorate([
        mobx_1.observable.ref
    ], Supplier.prototype, "_value", void 0);
    __decorate([
        mobx_1.computed
    ], Supplier.prototype, "value", null);
    __decorate([
        mobx_1.action
    ], Supplier.prototype, "setValue", null);
    __decorate([
        mobx_1.action
    ], Supplier.prototype, "clearValue", null);
    return Supplier;
}());
exports.Supplier = Supplier;
